import ProductPageLayout, { ProductPageConfig } from "@/components/products/ProductPageLayout";
import sacKraftSos from "@/assets/products/sac-kraft-sos.png";
import sacKraftPoignees from "@/assets/products/sac-kraft-poignees.png";
import sacKraftPoigneesPlates from "@/assets/products/sac-kraft-poignees-plates.png";

const config: ProductPageConfig = {
  name: "Sacs kraft personnalisables",
  breadcrumbName: "Sacs kraft",
  subtitle: "Sacs en papier kraft disponibles en blanc ou kraft naturel",
  features: ["FSC certifié", "100% recyclable", "Personnalisable", "Disponible en stock", "Blanc ou Kraft"],
  variants: [
    { name: "Sac petit", dimensions: "H 280 x A 200 x L 100 mm", material: "Papier kraft", packaging: "Carton de 250", palette: "56 cartons", image: sacKraftSos },
    { name: "Sac à anses torsadées", dimensions: "H 290 x A 280 x L 170 mm", material: "Papier kraft", packaging: "Carton de 250", palette: "48 cartons", image: sacKraftPoignees },
    { name: "Sac à anses plates", dimensions: "H 290 x A 280 x L 170 mm", material: "Papier kraft", packaging: "Carton de 250", palette: "56 cartons", image: sacKraftPoigneesPlates },
  ],
  customization: { maxColors: 4, minOrder: "10 000 pièces", bestPrice: "100 000 pièces" },
};

const SacsKraft = () => <ProductPageLayout config={config} />;
export default SacsKraft;
